module.exports = __webpack_public_path__ + "static/img/11.9f5381b7.jpg";